import { render, staticRenderFns } from "./labDataCard.vue?vue&type=template&id=370f70ff"
import script from "./labDataCard.vue?vue&type=script&lang=ts"
export * from "./labDataCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports